<template>
  <div class="view news-view">
    <NavBar :itemList="navItemList" :selectedItemId="selectedNavItem" />
    <van-swipe @change="onSwipeChange" :loop="false">
      <van-swipe-item v-for="item in navItemList" :key="item.id">
        <Index
          :bannerList="bannerList"
          :latestCourseList="latestCourseList"
          :recommCourseList="recommCourseList"
          :hotCourseList="hotCourseList"
        />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant';
import apiUtil from '../../utils/apiUtil';
import apiConst from '../../consts/apiConst';
import NavBar from '../../components/NavBar';
import Index from './Index.vue';
export default {
  name: 'news',
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    NavBar,
    Index
  },
  data() {
    return {
      selectedNavItem: 0,
      bannerList: [],
      navItemList: [],
      latestCourseList: [],
      recommCourseList: [],
      hotCourseList: []
    };
  },
  created() {
    this.initIndexView();
  },
  methods: {
    onSwipeChange(index) {
      const id = this.navItemList[index].id;
      this.selectedNavItem = id;
      this.initIndexView(id);
    },

    async initIndexView(id) {
      const res = await apiUtil.post(apiConst.getNewsList, { cate_id: id });
      if (res) {
        const { home_banner, category, study } = res;
        if (this.selectedNavItem === 0) {
          this.selectedNavItem = category[0].id;
        }
        this.navItemList = category;
        this.bannerList = home_banner;
        if (study.hasOwnProperty('latest')) {
          this.latestCourseList = study.latest;
        }
        if (study.hasOwnProperty('recommend')) {
          this.recommCourseList = study.recommend;
        }
        if (study.hasOwnProperty('play_list')) {
          this.hotCourseList = study.play_list;
        }
      }
    }
  }
};
</script>
<style lang="stylus">
.news-view {
  position: relative;
  top: 176px;
	.swiper-view {
		.news-list {
			padding: 0 15px;
		}

		.banner-img {
			display: block;
			width: 100%;
			height: 100%;
			border-radius: 12px;
		}
	}
}
</style>
